export default __webpack_public_path__ + "static/media/logo.576355cf.svg";